import { render, staticRenderFns } from "./edicao_prefeitura.vue?vue&type=template&id=54625e3a"
import script from "./edicao_prefeitura.vue?vue&type=script&lang=js"
export * from "./edicao_prefeitura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports